module.exports = __webpack_public_path__ + "static/media/Sponge, Chiffon, & Angel Food Cakes.fefb55b2.jpg";